module.exports = __webpack_public_path__ + "static/img/movil.4791b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movil.png
// module id = XH6T
// module chunks = 1